import './QuemSomos.css';
import { Simbolo } from '../Logo/Logo';
import { IconeAtividade, IconeConversa, IconePessoa } from '../Icones/Icones';

const ETAPAS = [
    { titulo: 'Entender a operação', texto: 'Sentamos com quem vai usar o sistema.' },
    { titulo: 'Construir sob medida', texto: 'O sistema segue o processo, e não o contrário.' },
    { titulo: 'Virar produto', texto: 'O que funciona no cliente vira solução para outros.' },
];

const PILARES = [
    {
        Icone: IconeConversa,
        titulo: 'Conversa antes de código',
        texto: 'Entendemos o processo antes de propor tela.',
    },
    {
        Icone: IconeAtividade,
        titulo: 'Sistema em uso, não protótipo',
        texto: 'Nossos produtos rodam em empresas reais.',
    },
    {
        Icone: IconePessoa,
        titulo: 'Suporte de quem fez',
        texto: 'Você fala direto com quem desenvolveu.',
    },
];

function QuemSomos() {
    return (
        <section id="quem-somos" className="secao quem-somos">
            <div className="container">
                <div className="quem-somos-grade">
                    <div className="quem-somos-texto revelar">
                        <span className="rotulo">Quem somos</span>
                        <h2 className="titulo-secao">A gente começou pelo sob medida.</h2>
                        <p>
                            A C1010 nasceu escrevendo sistemas para empresas com problemas específicos. Primeiro a
                            gente senta com quem vai usar, entende como o trabalho acontece de verdade e só depois
                            desenha o sistema.
                        </p>
                        <p>
                            Foi assim que surgiram nossos produtos. O Gerenciador de Transportes começou no dia a dia
                            de uma transportadora. O Torque começou dentro de uma oficina mecânica. Os dois continuam
                            em uso por essas empresas e evoluem com o que elas pedem.
                        </p>
                        <p>
                            Seguimos fazendo projetos sob demanda. Se a sua operação tem um jeito próprio de
                            funcionar, é esse tipo de problema que a gente gosta de resolver.
                        </p>
                    </div>

                    <div className="quem-somos-painel revelar" style={{ '--atraso': '0.12s' }}>
                        <Simbolo className="painel-simbolo" />
                        <p className="painel-titulo">Do sob medida ao produto próprio</p>
                        <ol className="painel-etapas">
                            {ETAPAS.map((etapa, i) => (
                                <li key={etapa.titulo}>
                                    <span className="painel-numero">{String(i + 1).padStart(2, '0')}</span>
                                    <div>
                                        <strong>{etapa.titulo}</strong>
                                        <p>{etapa.texto}</p>
                                    </div>
                                </li>
                            ))}
                        </ol>
                    </div>
                </div>

                <ul className="pilares">
                    {PILARES.map(({ Icone, titulo, texto }, i) => (
                        <li key={titulo} className="pilar revelar" style={{ '--atraso': `${i * 0.1}s` }}>
                            <span className="pilar-icone"><Icone tamanho={22} /></span>
                            <h3>{titulo}</h3>
                            <p>{texto}</p>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
}

export default QuemSomos;
